import React, { useState } from 'react';
import Sidebar from './Sidebar';
import Navbar from './Navbar';

function Layout({ children, noSidebar = false, defaultSidebarOpen = true }) {
  const [sidebarOpen, setSidebarOpen] = useState(defaultSidebarOpen);

  return (
    <div className="flex h-screen bg-[#fcfcfc] text-gray-800 overflow-hidden">
      {!noSidebar && <Sidebar open={sidebarOpen} setSidebarOpen={setSidebarOpen} />}

      {!noSidebar && sidebarOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-40 z-30 md:hidden"
          onClick={() => setSidebarOpen(false)}
        ></div>
      )}

      <div className="flex-1 flex flex-col overflow-hidden min-w-0">
        <Navbar onToggleSidebar={() => {
          if (!noSidebar) setSidebarOpen(!sidebarOpen);
        }} />

        <main className="flex-1 overflow-y-auto">
          {children}
        </main>

        <footer className="text-xs sm:text-sm text-gray-500 py-2 border-t border-gray-100 bg-[#fcfcfc]">
          © {new Date().getFullYear()}{' '}
          <a
            href="https://enovasolutions.com/"
            target="_blank"
            rel="noopener noreferrer"
            className="hover:underline"
          >
            eNova Software & Hardware Solutions
          </a>. All rights reserved.
        </footer>

      </div>
    </div>
  );
}


export default Layout;
